export enum FilterControlNameEnum {
  type,
  price,
  homeType,
  beds,
  condition,
  more,
  rooms,
}
